export default "__VITE_ASSET__B0IaQvIl__"